import { ControlType, FetchStatus, Property, PropertyType } from "../../../base/types";
import { DataContextProvider, useDataContext } from "../../page/context";
import { FC, useEffect, useState } from "react";
import { IControlAttributes, IDataLink } from "../../../base/models";

import { AlertMessage } from "../../../widgets";
import { DataContextProducer } from "../../page/context/DataContextProducer";
import { IFilterGroup } from "../../../data";
import { Registry } from "../../../base/register";
import { getQueryFields } from "../../helpers";
import { useGetProperties } from "../../../base/hooks";

export const DataLinkComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties, getBinding } = useGetProperties({ bindings: control.bindings });
    const dataLink: IDataLink | undefined = properties[Property.DataLink]
    const produce = dataLink?.dataSet === true ? "RecordSet" : "Record"
    const filters: IFilterGroup[] = [{ group: 0, filters: dataLink?.filters || [] }]
    const fields = getQueryFields(control.controls || [], [], []);
    const [dataLinkConfig, setDataLinkConfig] = useState<IDataLink>()

    useEffect(() => {
        var dataLinkValue = getBinding(Property.DataLink)?.value as IDataLink
        setDataLinkConfig(dataLinkValue)
        // eslint-disable-next-line
    }, [])

    if (!dataLink || !dataLinkConfig?.entity || (produce === "Record" && !dataLinkConfig?.systemId)) {
        return <div className={className}>
            <DataContextProvider>
                {children}
            </DataContextProvider>
        </div>
    }

    return (<div className={className}>
        <DataContextProvider>
            <DataContextProducer
                produce={produce}
                entity={dataLink.entity}
                systemId={dataLink.systemId}
                fields={fields}
                filters={filters} />
            {dataLink.entity && <>
                <DataLinkStatus />
                {children}
            </>}
        </DataContextProvider>
    </div>)
}

const DataLinkStatus = () => {
    const { status, error } = useDataContext()

    return <>
        <AlertMessage type="Error" show={status === FetchStatus.Error} message={error} />
    </>
}

Registry.addControl({
    id: "264ab93f-afc7-4986-94a3-b573ff9b700a",
    name: "Data Link",
    type: ControlType.DataLink,
    properties: [
        { id: Property.DataLink, name: 'Data Link', type: PropertyType.DataLink },
    ],
    component: DataLinkComponent
})
